import React, { forwardRef } from 'react'

const MenuIcon = forwardRef(({activeText}, ref) => {
    return (
        <>
            <input id="hamburger" class="hamburger" type="checkbox" ref={ref} />
            <label class="hamburger" for="hamburger">
                <i></i>
                <text>
                <close>Zavřít</close>
                <open>{activeText}</open>
                </text>
            </label>
        </>

    )
})

export default MenuIcon